import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/headImg.png'


const _withScopeId = n => (_pushScopeId("data-v-32578755"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "|", -1))
const _hoisted_2 = {
  key: 0,
  class: "mobileBox"
}
const _hoisted_3 = {
  key: 0,
  class: "tag"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "userList" }
const _hoisted_8 = ["textContent"]
const _hoisted_9 = ["textContent"]
const _hoisted_10 = ["textContent"]

import { h, computed } from "vue";
import i18n from "@/lang";
import { ElMessageBox, ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import { logout, zhEnConversion } from "@/utils";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  emits: ["close"],
  setup(__props, { emit }) {

// import store from "@/store";

const store = useStore();
const isLogin = computed(() => !!store.state.isLogin);
const isMobile = computed(() => !!store.state.isMobile);

const router = useRouter();
const t = i18n.global.t;
const handleLogin = () => {
  if (!isMobile.value) {
    store.commit("showLogin");
  } else {
    router.push({ name: "login" });
    emit("close");
  }
};
const handleLogout = () => {
  ElMessageBox({
    message: h("p", null, [
      h(
        "div",
        { style: "padding-bottom: 15px ; padding-top:10px" },
        t("user_center.quit_login")
      ),
    ]),
    showCancelButton: true,
    confirmButtonText: t("user_center.confirm"),
    center: true,
    cancelButtonText: t("user_center.cancel"),
    customClass: "header-dialog",
    beforeClose: (action, instance, done) => {
      if (action === "confirm") {
        logout();
        emit("close");
        done();
      } else {
        done();
      }
    },
  })
    .then((action) => {
      ElMessage({
        type: "success",
        message: t("user_center.exit_success"),
      });
    })
    .catch((res) => {});
};
const handleRegister = () => {
  if (!isMobile.value) {
    store.commit("showRegister");
  } else {
    router.push({ name: "register" });
    emit("close");
  }
};
const changeRouter = (path: string) => {
  if (path == "/userCenter" || path == "/userCenter/account") {
    store.dispatch("getUserInfo");
  }
  router.push({
    path,
  });
  emit("close");
};

return (_ctx: any,_cache: any) => {
  return (!_unref(isLogin))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['login', { mobileSize: _unref(isMobile) }])
      }, [
        _createElementVNode("span", { onClick: handleLogin }, _toDisplayString(_ctx.$t("header.login")), 1),
        _hoisted_1,
        _createElementVNode("span", { onClick: handleRegister }, _toDisplayString(_ctx.$t("header.signUp")), 1)
      ], 2))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(['userInfo', { mobileSize: _unref(isMobile) }])
      }, [
        (_unref(isMobile))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_unref(store).state.userInfo.serviceType != 4)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(zhEnConversion)(_unref(store).state.userInfo.title)), 1))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: "name",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (changeRouter('/userCenter')))
              }, _toDisplayString(_unref(store).state.userInfo.nickName), 1),
              _createElementVNode("span", {
                class: "logout",
                onClick: handleLogout
              }, _toDisplayString(_ctx.$t("user_center.quit")), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "userImg",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (changeRouter('/userCenter')))
              }, [
                _hoisted_5,
                (_unref(store).state.userInfo.serviceType != 4)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(zhEnConversion)(_unref(store).state.userInfo.title)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", {
                    class: "nick-name",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (changeRouter('/userCenter')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_unref(store).state.userInfo.nickName), 1)
                  ]),
                  _createElementVNode("li", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (changeRouter('/userCenter')))
                  }, [
                    _createElementVNode("a", {
                      href: "javascript:void(0);",
                      textContent: _toDisplayString(_ctx.$t('user_center.personal_info'))
                    }, null, 8, _hoisted_8)
                  ]),
                  _createElementVNode("li", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (changeRouter('/userCenter/account')))
                  }, [
                    _createElementVNode("a", {
                      href: "javascript:void(0);",
                      textContent: _toDisplayString(_ctx.$t('user_center.order_info'))
                    }, null, 8, _hoisted_9)
                  ]),
                  _createElementVNode("li", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (changeRouter('/userCenter/amend-password')))
                  }, [
                    _createElementVNode("a", {
                      href: "javascript:void(0);",
                      textContent: _toDisplayString(
                !_unref(store).state.userInfo.setPassword
                  ? _ctx.$t('user_center.set_password')
                  : _ctx.$t('user_center.change_password')
              )
                    }, null, 8, _hoisted_10)
                  ])
                ]),
                _createElementVNode("p", { onClick: handleLogout }, _toDisplayString(_ctx.$t("user_center.quit")), 1)
              ])
            ]))
      ], 2))
}
}

})